import { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { AppStateContext, NetworkStateContext } from "../common/utils/AppStateContext"
import { online, offline, selectOnline } from '../reducers/appSlice.js'
import { getToken, getRefreshToken } from "../reducers/authSlice"
import { signIn, signOut } from "../common/reducers/initContext.js"
import { credentialsFactory } from "./accessUtilities.js"

export const NetworkStateProvider = ({ children }) => {
    const isOnline = useSelector(selectOnline);
    const [wsStatus, setWSStatus] = useState('closed');

    const value = useMemo(() => ({
        online,
        offline,
        isOnline,
        wsStatus,
        setWSStatus
    }), [isOnline, wsStatus]);

    return <NetworkStateContext.Provider value={value}>
        {children}
    </NetworkStateContext.Provider>
}

export const AppStateProvider = ({ children }) => {
    const token = useSelector(getToken);
    const refreshToken = useSelector(getRefreshToken);
    const credentials = useMemo(() => credentialsFactory(token), [token]);

    const value = useMemo(() => ({
        token,
        refreshToken,
        signIn,
        signOut,
        credentials
    }), [token, refreshToken, credentials]);

    return <AppStateContext.Provider value={value}>
        <NetworkStateProvider>
            {children}
        </NetworkStateProvider>
    </AppStateContext.Provider>
}
